export default {
    colorMode: true,
    myCoffees: {},
    showCuppingSettings: false,
    myPublicData: {},
    myPrivateData: {},
    anonUser: true,
    uidNotPresent: false,
    myCurrentCupping: false,

    showHeaderShop: false,
    loaded: false,
    uid: '',
    email: '',
    profilePic: false,
    username: false,
    accountCreated: false,
    test: 'success!',
    friendsData: {},
    friendsDataArray: [],
    authError: false
}


// WEBPACK FOOTER //
// ./src/services/AUTH/state/index.js